import React, { useEffect, useState, useRef } from "react";
import { array, number, bool, node, func } from "prop-types";

import "./srollSnap.m.css";

const ScrollSnap = ({ children, defaultSelection, isArrow, leftArrow, rightArrow, handleNextClick }) => {
  const [selectedIndex, setSelectedIndex] = useState(defaultSelection ? defaultSelection - 1 : 0);
  const [imageHeight, setImageHeight] = useState("");

  const noOfItems = children ? children.length : 0;
  const scroller = useRef(null);

  const debounce = (func, ms) => {
    let timeout;

    return () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func();
      }, ms);
    };
  };

  useEffect(() => {
    if (scroller.current) {
      scroller.current.addEventListener(
        "scroll",
        debounce(() => {
          const index = Math.round((scroller.current.scrollLeft / scroller.current.scrollWidth) * noOfItems);
          setSelectedIndex(index);
        }, 150)
      );

      // For Default Selection if selectedIndex is not 0 then manually select it
      if (selectedIndex !== 0) {
        updateItemSelection(selectedIndex);
      }
    }

    return () => {
      scroller.current.removeEventListener("scroll", debounce);
    };
  }, []);

  useEffect(() => {
    if (selectedIndex !== defaultSelection) {
      updateItemSelection(defaultSelection);
    }
  }, [defaultSelection]);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const ImageHeight = document.querySelector("#slidehow-image_wrapper")?.clientHeight;
      setImageHeight(ImageHeight);
    }
  }, []);

  const smoothScroll = (node, topOrLeft, horizontal) => {
    return node.scrollTo({
      [horizontal ? "left" : "top"]: topOrLeft,
      behavior: "smooth"
    });
  };

  const nextClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (scroller.current) {
      if (selectedIndex < noOfItems) {
        const newIndex = selectedIndex + 1;
        setSelectedIndex(newIndex);
        updateItemSelection(newIndex);
        handleNextClick && handleNextClick();
      }
    }
  };

  const previousClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (scroller.current) {
      const newIndex = selectedIndex - 1;
      setSelectedIndex(newIndex);
      updateItemSelection(newIndex);
    }
  };

  const updateItemSelection = (index) => {
    const scrollLeft = Math.floor(scroller.current.scrollWidth * (index / noOfItems));
    smoothScroll(scroller.current, scrollLeft, true);
  };

  const arrowView = () => (
    <div style={{ height: imageHeight }} styleName="srollsnap-arrow-wrapper">
      {/* Left Arrow Button */}
      {selectedIndex !== 0 ? (
        <span onClick={previousClick} styleName="arrow left-arrow" className="left-arrow">
          {leftArrow}
        </span>
      ) : null}

      {/* Right Arrow Button */}
      {selectedIndex < noOfItems - 1 ? (
        <span onClick={nextClick} styleName="arrow right-arrow" className="right-arrow">
          {rightArrow}
        </span>
      ) : null}
    </div>
  );

  return (
    <div>
      <div styleName="wrapper" className="scroll-snap-wrapper">
        <div ref={scroller} styleName="carousel" className="scroll-snap-carousel">
          {children}
        </div>
        {isArrow ? arrowView() : null}
      </div>
    </div>
  );
};

ScrollSnap.defaultProps = {
  isArrow: true,
  defaultSelection: 0
};

ScrollSnap.propTypes = {
  children: array.isRequired,
  leftArrow: node.isRequired,
  rightArrow: node.isRequired,
  defaultSelection: number,
  isArrow: bool,
  handleNextClick: func
};

export default ScrollSnap;
